import React, { useEffect, useState } from 'react';
import { Car, X } from 'lucide-react';
import { vehiclesAPI } from '../services/api';

const cls = 'border border-gray-300 rounded-md px-2 py-0.5 text-sm bg-white max-w-[200px] disabled:bg-gray-100 disabled:text-gray-400';

// Admin products filter « compatibles avec … » : marque → modèle → motorisation
export const AdminVehicleFilter = ({ value, onChange, disabled = false }) => {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [engines, setEngines] = useState([]);

  useEffect(() => { vehiclesAPI.getBrands().then(setBrands).catch(() => setBrands([])); }, []);
  useEffect(() => {
    if (!value.brand) { setModels([]); return; }
    let cancelled = false;
    vehiclesAPI.getModels(value.brand).then(d => { if (!cancelled) setModels(d); }).catch(() => { if (!cancelled) setModels([]); });
    return () => { cancelled = true; };
  }, [value.brand]);
  useEffect(() => {
    if (!value.brand || !value.model) { setEngines([]); return; }
    let cancelled = false;
    vehiclesAPI.getBrandEngines(value.brand, [value.model]).then(d => { if (!cancelled) setEngines(d); }).catch(() => { if (!cancelled) setEngines([]); });
    return () => { cancelled = true; };
  }, [value.brand, value.model]);

  return (
    <span className="inline-flex flex-wrap items-center gap-1.5 text-sm text-gray-600" data-testid="products-vehicle-filter">
      <Car size={14} className={value.brand ? 'text-orange-500' : 'text-gray-400'} /> Compatibles avec
      <select data-testid="products-vehicle-brand" value={value.brand} disabled={disabled} onChange={(e) => onChange({ brand: e.target.value, model: '', engine: '' })} className={cls}>
        <option value="">Tous véhicules</option>
        {brands.map(b => <option key={b} value={b}>{b}</option>)}
      </select>
      {value.brand && (
        <select data-testid="products-vehicle-model" value={value.model} disabled={disabled} onChange={(e) => onChange({ ...value, model: e.target.value, engine: '' })} className={cls}>
          <option value="">Tous les modèles</option>
          {models.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
      )}
      {value.model && (
        <select data-testid="products-vehicle-engine" value={value.engine} disabled={disabled} onChange={(e) => onChange({ ...value, engine: e.target.value })} className={`${cls} max-w-[240px]`}>
          <option value="">Toutes motorisations</option>
          {engines.map(e => <option key={e.name} value={e.name}>{e.name}</option>)}
        </select>
      )}
      {value.brand && (
        <button type="button" data-testid="products-vehicle-clear" onClick={() => onChange({ brand: '', model: '', engine: '' })} className="p-0.5 text-gray-400 hover:text-red-600" title="Effacer le filtre véhicule"><X size={14} /></button>
      )}
    </span>
  );
};

export default AdminVehicleFilter;
